module.exports = __webpack_public_path__ + "files/b2399349300480c8de0be9b325e05543.png";